import React from 'react';
import { WarningCircle, ArrowClockwise } from 'phosphor-react';

class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[MapErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', gap: 16, padding: 48,
          background: '#fff', borderRadius: 12, border: '1px solid #D8DDD6',
          color: '#1B2820', textAlign: 'center',
          minHeight: this.props.minHeight || 300
        }}>
          <WarningCircle size={40} color="#dc2626" weight="duotone" />
          <div>
            <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>Map failed to load</div>
            <div style={{ fontSize: 13, color: '#6B8A6C' }}>
              {this.state.error?.message || 'An unexpected error occurred while rendering the map.'}
            </div>
          </div>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              display: 'flex', alignItems: 'center', gap: 8,
              padding: '9px 18px', background: '#3D5C3A', color: '#fff',
              border: 'none', borderRadius: 8, fontWeight: 600,
              fontSize: 14, cursor: 'pointer'
            }}
          >
            <ArrowClockwise size={16} /> Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default MapErrorBoundary;
